import AnnouncementIcon from '@mui/icons-material/Announcement';
import { Button, Checkbox, Divider, Typography } from "@mui/material";
import Chip from '@mui/material/Chip';
import Moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { auditColumnDefs } from "../../constants/QuestionBankConstants";
import Grid from '../../platform-components/grid/Grid';
import { apiPaths, get } from "../api-integration-util";
import BasicTabs from "../basic-tabs/BasicTabs";
import { getUserDetails } from "../utils/shared-data.service";
import "./questionviewer.scss";
import { Card } from '@material-ui/core';


const tabList = (props) => [
  {
    label: 'Tags',
    content: <>

      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "flex-start",
          marginBottom: "20px",
          flexWrap: "wrap",
          marginLeft: '15px'
        }}
      >
        <Card style={{ maxWidth: "270px" }}>
          <div style={{ marginLeft: "5px" }}>
            {props?.question_course_map?.length > 0 &&
              <div style={{padding: "5px" }}>
                <div style={{ display: "inline-block", verticalAlign: "middle" }}>
                  <strong style={{ marginRight: "10px" }}>Course</strong>
                  {(props?.question_course_map || []).map((el) => {
                    return (
                      <Chip label={el?.course} color="error" style={{ marginBottom: "5px", marginRight: "3px" }} ></Chip>
                    );
                  })}
                </div>
              </div>
            }

            {props?.question_tag_map?.length > 0 &&
              <div style={{ padding: "5px" }}>
                <div style={{ display: "inline-block", verticalAlign: "middle" }}>
                  <strong style={{ marginRight: "10px" }}>Tag</strong>
                  {(props?.question_tag_map || []).map((el) => {
                    return (
                      <Chip label={el?.tagName} color="error" style={{ marginBottom: "5px", marginRight: "3px" }} ></Chip>
                    );
                  })}
                </div>
              </div>
            }

            {props?.question_topic_map?.length > 0 &&
              <div style={{ padding: "5px" }}>
                <div style={{ display: "inline-block", verticalAlign: "middle" }}>
                  <strong style={{ marginRight: "10px" }}>Topic</strong>
                  {(props?.question_topic_map || []).map((el) => {
                    return (
                      <Chip label={el?.topic} color="error" style={{ marginBottom: "5px", marginRight: "3px" }} ></Chip>
                    );
                  })}
                </div>
              </div>
            }

            {props?.questionType &&
              <div style={{padding: "5px" }}>
                <div style={{ display: "inline-block", verticalAlign: "middle" }}>
                  <strong style={{ marginRight: "10px" }}>Complexity</strong>
                  <Chip label={props?.questionType} size="small" color="primary" style={{ marginBottom: "5px", marginRight: "3px" }} ></Chip>
                </div>
              </div>
            }

            {props?.subject &&
              <div style={{ padding: "5px" }}>
                <div style={{ display: "inline-block", verticalAlign: "middle" }}>
                  <strong style={{ marginRight: "10px" }}>Subject</strong>
                  <Chip label={props?.subject} size="small" color="secondary" style={{ marginBottom: "5px", marginRight: "3px" }} ></Chip>
                </div>
              </div>
            }
          </div>
        </Card>
      </div>

    </>
  }, {
    label: 'Audits',
    content: <><div style={{ width: "100%", padding: "10px" }}>
      <div className="">
        <p>
          <Typography variant="overline" gutterBottom>
            Comments:
          </Typography>
        </p>
        <p>
          <Typography variant="caption" gutterBottom>
            Created by:{" "}
            <span style={{ color: "blue", textDecoration: "underline" }}>
              {props?.createdBy}
            </span>
          </Typography>
        </p>
        <p>
          <Typography variant="caption" gutterBottom>
            Created date: {Moment(props?.createdDate).format("DD-MM-YYYY")}
          </Typography>
        </p>
        <p>
          <Typography variant="caption" gutterBottom>
            Updated by:{" "}
            <span style={{ color: "blue", textDecoration: "underline" }}>
              {props?.updatedBy}
            </span>
          </Typography>
        </p>
        <p>
          <Typography variant="caption" gutterBottom>
            Updated date:{Moment(props?.updatedDate).format("DD-MM-YYYY")}
          </Typography>
        </p>
      </div>
    </div></>
  }
]

const questionTabList = (props) => [{
  
  label: 'Detail',
  content: <><div style={{ marginTop: "15px" }}>
    {(props?.answers || []).map((ans, idx) => (
      <p style={{ display: "flex" }}>
        {idx + 1}) &nbsp;
        <div
          style={{ fontWeight: ans?.correct ? "900" : "400" }}
          dangerouslySetInnerHTML={{ __html: ans?.answer }}
        />
      </p>
    ))}
  </div>
    <div>
      <p>
        <p style={{ textDecoration: "underline" }}>
          Explanation:
        </p>
        <div
          style={{ padding: "10px" }}
          dangerouslySetInnerHTML={{ __html: props?.explanation }}
        />
      </p>
    </div>
    <p style={{ display: "flex" }}>
      <p style={{ textDecoration: "underline" }}>References:</p>
      <div
        style={{ padding: "10px" }}
        dangerouslySetInnerHTML={{ __html: props?.reference }}
      />
    </p></>
}, {
  label: 'History',
  content: <>
    {props?.displayAudit && (props?.auditGridOptions?.rowData || []).length > 0 && <Grid gridOptions={props?.auditGridOptions} />}
  </>
},
{
  label: 'Where used',
  content: <>
    {props?.showWhereUsedGrid && (props?.whereUsedPopupgridOptions?.rowData || []).length > 0 && <Grid
      gridOptions={props?.whereUsedPopupgridOptions}
    />}
  </>
},
{
  label: 'Student feedback',
  disabled: false,
  content: <>
    {props?.showWhereUsedGrid && (props?.feedbackPopupgridOptions?.rowData || []).length > 0 && (
      <Grid
        gridOptions={props?.feedbackPopupgridOptions}
      />
    )}
  </>
},
]

export default function QuestionViewer(props) {
  
  const [showTable, setShowTable] = useState(true)
  const [loaded, setLoaded] = useState(false)
  let [auditGridOptions, setAuditGridOptions] = useState({});
  let [displayAudit, setDisplayAudit] = useState(false);
  let auditGridApi = useRef();

  useEffect(() => {
    setLoaded(false)
    setShowTable(false)
    setShowTable(true)
    if(props.questionId){
    get(apiPaths.questionstatusaudit, { questionId: props?.questionId, tenantId: getUserDetails().tenantId })
      .then((res) => {
        setDisplayAudit(false);
        if (res?.result) {
          auditGridOptions.columnDefs = auditColumnDefs;
          res.result.sort((e1, e2) => e2.auditId - e1.auditId);
          auditGridOptions.rowData = res?.result;
          auditGridOptions.paginationPageSize = 20;
          auditGridOptions.pagination = true;
          auditGridOptions.domLayout = '';
          auditGridOptions.onGridReady = (params) => {
            auditGridApi.current = params.api;
          };
          setTimeout(() => auditGridApi?.current?.setRowData(res?.result));
          setDisplayAudit(true);
        }
      })
      .catch((ele) => {
      });
    setTimeout(() => setLoaded(true), 500)
    }
  }, [props?.questionId])

  if (!props?.questionId) {
    return <>{loaded && <div style={{ fontSize: '20px', display: 'flex', flexFlow: 'column', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
      <p><AnnouncementIcon fontSize="large" /></p>
      <p>No question present with this question Id</p>
    </div>}</>
  }
  return (
    <div style={{ background: "white", borderRadius: "15px", padding: "10px" }}>
      <div style={{ display: "flex", minHeight: "72vh" }}>
        <div className="col-sm-9" style={{ maxHeight: '70vh', overflow: 'auto' }}>
          <div style={{ width: "100%" }}>

            <div>
              <div style={{ margin: "10px 0" }}>
                <div style={{ display: 'flex' }}>{props?.questionId}. <div dangerouslySetInnerHTML={{ __html: props?.question }} /></div>
              </div>
            </div>
            <BasicTabs tabList={questionTabList({ ...props, displayAudit: displayAudit, auditGridOptions: auditGridOptions })} />

          </div>
        </div>
        <Divider orientation="vertical" flexItem />
        <BasicTabs tabList={tabList(props)} />

      </div>
      {props?.selectable && <><Checkbox onChange={(e) => {
        props.onSelect(props?.questionId, e.target.checked)
      }} checked={props?.manualQuestions.includes(props?.questionId)} /> Question is selected </>}
      <Divider light />
      {sessionStorage.getItem("routeFrom") !== 'dashboard' && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "16px",
          }}
        >
          <Button
            type="submit"
            variant="outlined"
            disabled={+(props?.questionId || 0) < 2 || !props?.prevQuestion || props?.prevQuestion === props?.questionId}
            onClick={() => {
              props.setId(props?.prevQuestion);
            }}
            color="primary"
          >
            Previous
          </Button>
          <Typography variant="caption" display="block" gutterBottom>
            QuestionId: {props?.questionId}
          </Typography>

          <Button
            type="submit"
            variant="outlined"
            color="primary"
            disabled={+(props?.count || 0) === +props?.questionId || props?.nxtQuestion === props?.questionId}
            onClick={() => {
              props.setId(props?.nxtQuestion);
            }}
          >
            Next
          </Button>
        </div>
      )}

      {sessionStorage.getItem("routeFrom") === 'dashboard' && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "16px",
          }}
        >
          <Button
            type="submit"
            variant="outlined"
            color="primary"
            disabled={+(props?.count || 0) === +props?.questionId || +props?.nxtQuestion === 0}
            onClick={() => {
              props.setId(props?.nxtQuestion);
            }}
          >
            Previous
          </Button>

          <Typography variant="caption" display="block" gutterBottom>
            QuestionId: {props?.questionId}
          </Typography>

          <Button
            type="submit"
            variant="outlined"
            disabled={+(props?.questionId || 0) < 2 || +props?.prevQuestion === 0 || !props?.prevQuestion}
            onClick={() => {
              props.setId(props?.prevQuestion);
            }}
            color="primary"
          >
            Next
          </Button>
        </div>
      )}
    </div>
  );
}
